import { gql, useQuery } from "@apollo/client";

import { useTenant } from "@/providers/session";

export const useGetAllDatevTokens = ({
  skipPermissionsCheck,
  fetchPolicy,
}: {
  skipPermissionsCheck?: boolean;
  fetchPolicy?: "network-only";
} = {}) => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery(DATEV_TOKENS_QUERY, {
    variables: { tenantId, skipPermissionsCheck },
    fetchPolicy,
  });

  return { tokens: data?.datevTokens ?? [], error, loading, refetch };
};

export const DATEV_TOKENS_QUERY = gql`
  query DatevTokens($tenantId: String!, $skipPermissionsCheck: Boolean) {
    datevTokens(tenantId: $tenantId, skipPermissionsCheck: $skipPermissionsCheck) {
      datevTokenId
      clientId
      refreshTokenExpirationDate
      createdAt
      issuedBy
      error
    }
  }
`;
